import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "final-checks"
    }}>{`Final checks`}</h2>
    <p>{`That's all.`}</p>
    <p>{`If you:`}</p>
    <ol>
      <li parentName="ol">{`Run cezerin.`}</li>
      <li parentName="ol">{`Run webserver nginx with cezerin config.`}</li>
      <li parentName="ol">{`Setup DNS records.`}</li>
    </ol>
    <p>{`You will see working store in your browser by this urls:`}</p>
    <p>{`Store: `}<a parentName="p" {...{
        "href": "https://your-domain-name.com"
      }}>{`https://your-domain-name.com`}</a></p>
    <p>{`API: `}<a parentName="p" {...{
        "href": "https://your-domain-name.com/api/v1/settings"
      }}>{`https://your-domain-name.com/api/v1/settings`}</a></p>
    <p>{`Dashboard: `}<a parentName="p" {...{
        "href": "https://your-domain-name.com/admin"
      }}>{`https://your-domain-name.com/admin`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      